import { useQueryClient } from "@tanstack/react-query"
import { useState } from "react"
import { userQueryOptions } from "../auth/user-query"
import type { User } from "./types"
import { useCurrentUserId } from "./use-current-user-id"

/**
 * Snapshot of the current user taken from `byId` on mount; it does **not**
 * follow later cache updates. Only inside `/_authenticated`, where the root
 * check has put the user in the cache.
 *
 * Use it for the initial state of editor screens: a reactive source breaks
 * `isDirty` once a mutation writes the cache. For showing user fields use
 * {@link useCurrentUser}, for the id — {@link useCurrentUserId}.
 */
export function useCurrentUserSnapshot(): User {
	const userId = useCurrentUserId()
	const queryClient = useQueryClient()
	const [user] = useState(() => {
		const cached = queryClient.getQueryData(userQueryOptions(userId).queryKey)
		if (!cached) {
			throw new Error("The current user is missing from the query cache")
		}
		return cached
	})
	return user
}
